export const EXPERIMENTS_ENABLED_KEY = 'experiments_enabled'
export const EXPERIMENT_KEY_PREFIX = 'exp_'
export const CONTROL_VARIANT = 'control'

export const REMOTE_CONFIG_DEFAULTS = {
  [EXPERIMENTS_ENABLED_KEY]: true,
  exp_header_cashier: CONTROL_VARIANT,
}

export const MAX_PENDING_ANALYTICS_CALLS = 50

export const RC_READY_TIMEOUT_MS = 2000
export const RC_FETCH_TIMEOUT_MS = 10_000
export const RC_MIN_FETCH_INTERVAL_MS = 3_600_000
